<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">"{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("thirdparty.new") }}</span>
      </h2>

      <!-- form input start-->
      <sweet-input
        v-model="form.name"
        :isValid="!$v.form.name.$error"
        @input="$v.form.name.$touch()"
        layout="vertical"
        :placeholder="$t('common.name')"
        :label="$t('thirdparty.text')"
      />

      <h6 class="mt-4">{{ $t("receiver-group.text") }}</h6>
      <filter-select
        id="receiverGroupFilter"
        ref="receiverGroupFilter"
        :placeholder="$t('receiver-group.text')"
        :multiple="false"
        @filter="onReceiverGroupSearch"
        :selected="form.receiverGroup"
        @changed="onReceiverGroupSelect"
        :validation="true"
        :isValid="!$v.form.receiverGroup.$invalid"
      />

      <label class="mt-2">{{ $t("country.name") }}</label>
      <filter-select
        class="mb-2"
        id="countryFilter"
        ref="countryFilter"
        :placeholder="$t('country.select')"
        :multiple="false"
        @filter="onCountrySearch"
        :selected="form.country"
        @changed="onCountrySelect"
        track="code"
        :validation="true"
        :isValid="!$v.form.country.$invalid"
      />

      <strong v-if="form.country && currentOrganization.country.code != form.country.code" class="text-danger ml-1"> {{ $t("thirdparty.country-alert") }}</strong>

      <label class="mt-2">{{ $t("agreement-type.text") }}</label>

      <right-panel class="float-right" id="sidebar-new-agreement-type" width="650px" :icon="'mdi mdi-plus'" :text="$t('agreement-type.new')">
        <div class="pl-5 pr-5">
          <AgreementTypeFrom />
        </div>
      </right-panel>

      <filter-select
        id="agreementTypeFilter"
        ref="agreementTypeFilter"
        :placeholder="$t('agreement-type.text')"
        :multiple="false"
        @filter="onAgreementTypeSearch"
        :selected="form.agreementType"
        @changed="onAgreementTypeSelect"
        :validation="true"
        :isValid="!$v.form.agreementType.$invalid"
      />

      <label class="mt-2">{{ $t("thirdparty.direction") }}</label>

      <select v-model="form.direction" class="form-control">
        <option value="NONE">{{ $t("thirdparty.none") }}</option>
        <option value="EXPORT">{{ $t("thirdparty.export") }}</option>
        <option value="IMPORT">{{ $t("thirdparty.import") }}</option>
        <option value="BOTH">{{ $t("thirdparty.both") }}</option>
      </select>

      <b-form-checkbox switch v-model="form.softwareProvider" class="mt-3">
        {{ $t("thirdparty.software-provider") }}
      </b-form-checkbox>

      <br />
      <sweet-button @click="save()" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>

  <!-- form input end -->
</template>

<script>
import AgreementTypeFrom from "@modules/agreement-type/workspace-library-agreement-type-form";
import { maxLength, minLength, required } from "vuelidate/lib/validators";
import Countries from "../countries/countries.json";
export default {
  components: { AgreementTypeFrom },
  data() {
    return {
      form: {
        name: undefined,
        direction: "NONE",
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
      country: {
        required,
      },
      agreementType: {},
      receiverGroup: {
        required,
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`organizationThirdParty/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`organizationThirdParty/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`organizationThirdParty/isEditMode`];
    },
  },
  mounted() {},
  methods: {
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        const response = await this.$store.dispatch(`organizationThirdParty/save`, this.form);
        this.form = {};
        this.$toast.success(this.$t("common.success"));
        this.$root.$emit("bv::toggle::collapse", "sidebar-new-thirdparty");
        this.$emit("onSave", response.data);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async onReceiverGroupSearch(value, callback) {
      const response = await this.$store.dispatch(`receiverGroup/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onReceiverGroupSelect(item) {
      this.form = { ...this.form, receiverGroup: item };
    },

    async onAgreementTypeSearch(value, callback) {
      const response = await this.$store.dispatch(`agreementType/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onAgreementTypeSelect(item) {
      this.form = { ...this.form, agreementType: item };
    },

    async onCountrySearch(value, callback) {
      const lang = "tr";
      const response = Countries.filter((x) => x.name[lang].toLowerCase().includes(value.toLowerCase()));
      callback(response);
    },
    onCountrySelect(item) {
      this.form = { ...this.form, country: item };
    },
  },
};
</script>
